import * as actionTypes from "../actions";
import merge from "lodash/merge";

const initialState = {
  client: null,
  user: null,
  loading: false,
  profile: null,
  customerTeam: [],
  userChoice: null,
  empProfile: null,
  custformech: null
};
const config = (state = initialState, action) => {
  let index = -1;
  switch (action.type) {
    case actionTypes.STORE_USER:
      return {
        ...state,
        user: action.data,
        loading: false
      };
    case actionTypes.STORE_CLIENT:
      return {
        ...state,
        client: action.data
      };
    case actionTypes.STORE_PROFILE:
      return {
        ...state,
        profile: action.data,
        loading: false
      };
    case actionTypes.STORE_EMP_PROFILE:
      return {
        ...state,
        empProfile: action.data,
        loading: false
      };
    case actionTypes.STORE_USER_CHOICE:
      return {
        ...state,
        userChoice: action.data,
        loading: false
      };
    case actionTypes.ADD_TEAM_MEMBER:
      if (action.data) {
        state.customerTeam.push(action.data);
      }
      return {
        ...state,
        customerTeam: state.customerTeam,
        loading: false
      };
    case actionTypes.UPDATE_TEAM:
      index = state.customerTeam.findIndex(e => e.id === action.data.id);

      if (index === -1) {
        state.customerTeam.push(action.data);
      } else {
        state.customerTeam[index] = action.data;
      }
      return {
        ...state,
        customerTeam: state.customerTeam,
        loading: false
      };
    case actionTypes.STORE_TEAM:
      return {
        ...state,
        customerTeam: action.data,
        loading: false
      };
    case actionTypes.UPDATE_PROFILE:
      if (action.data) {
        return ({ ...state, profile: action.data });
      }
      return state.profile;
    case actionTypes.UPDATE_EMP_PROFILE:
      if (action.data) {
        return merge({}, state.empProfile, action.data);
      }
      return state.empProfile;
    /*
      return Object.assign({}, state, {
        profile: state.profile
          .filter(item => {
            return item!== action.data]; //delete matched data
          })
          .concat(action.data) //concats new data
          
      });*/
    case actionTypes.STORE_CUSTFORMECH:
      return {
        ...state,
        custformech: action.data
      };
    default:
      return state;
  }
};
export default config;



// WEBPACK FOOTER //
// ./src/redux/reducers/config.js